import React from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

export default function DismissableSidebarPanel() {
  return (
    <section>
      <a className="anchor" id="dismissablesidebarpanel"></a>
      <h2>Dismissable Sidebar Panel</h2>

      <DarkThemeNav anchor="dismissableSidePanel" />
      <p>Dismissable Sidebar Panels are required for interfaces that do not overlay the content like drawers but rather take up a percentage of the UI and can be dismissed and launched from a click action</p>
      <p>The dismissable sidebar panel will default to the left hand side of the screen. To have is appear on the right add the helper <code>.is-right</code></p>
      <p>The example can be launched by clicking the notification bell in the header.</p>
      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
      </select>
      <br/><br/>
        <div className="iframe-container" style={{"height":"700px"}}>
          <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>
              <nav class="nav nav--global nav--dark drop-shadow js-nav">
                <div class="nav__inner">
                  <div class="nav__header nav__header--alternate">
                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                    <h1 class="nav__app-name">CME Institute</h1>
                  </div>
                  <ul class="nav__items--primary">
                    <li class="nav__item--primary"><a>Learn</a></li>
                    <li class="nav__item--primary"><a>Practice</a></li>
                    <li class="nav__item--primary"><a>Challenge</a></li>
                    <li class="nav__item--primary"><a>Markets</a></li>
                  </ul>
                  <ul class="nav__actions">
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
                    <li class="nav__action"><button class="nav__action-btn js-dismissable-sidebar-panel__open js-dismissable-sidebar-panel__remote-open"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
                  </ul>
                </div>
              </nav>
              <div class="dismissable-sidebar-panels js-dismissable-sidebar-panel is-title is-compact is-right">
                <div class="dismissable-sidebar-panels__wrapper">
                  <div class="dismissable-sidebar-panels__sidebar">
                    <div class="dismissable-sidebar-panels__sidebar--heading">
                      <h1 class="flush--bottom dismissable-sidebar-panels__sidebar--heading--title push-quarter--left">Events</h3>
                      <button class="btn btn--transparent dismissable-sidebar-panels__sidebar--heading--hide js-dismissable-sidebar-panel__close text--right hard">
                        <span class="dismissable-sidebar-panels__sidebar--heading--hide--icon">
                          <i class="icon-cme-card-close icon--medium"></i>
                        </span>
                        <span class="dismissable-sidebar-panels__sidebar--heading--hide--close">
                          <i class="icon-cme-close-circle-o"></i>
                        </span>
                      </button>
                    </div>

                    <div class="dismissable-sidebar-panels__sidebar--content"></div>
                  </div>
                  <div class="dismissable-sidebar-panels__content">
                    <div class="well well--border-color push">
                      <h3 class="flush">Results Content</h3>
                      <button class="btn dismissable-sidebar-panels__content--action js-dismissable-sidebar-panel__remote-open push--top">
                          <i class="dismissable-sidebar-panels__content--state js-dismissable-sidebar-panel__state fa icon-cme-filter"></i>
                          <span class="push-quarter--left">Events</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </body>
            <script type="text/javascript" src="js/commonUI.js"></script>
            <script>
              function init() {
                  commonUI.initializeDismissableSidebarPanel({
                    width: '50%',
                  });
              }
              window.onload = init;
            </script>
          </html>
        `}></iframe>
      </div>
      <br/>

          <p>Click 'View Source' to show the code for Dismissable Sidebar Panel.</p>

          <button type="button" className="btn btn--secondary show-code">
          <i className="fa fa-plus"></i>View source</button>
          <br/><br/>
          <pre className="hide-code">
         <code className="language-html">{`<nav class="nav nav--global nav--dark drop-shadow js-nav">
  <div class="nav__inner">
    <div class="nav__header nav__header--alternate">
      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      <h1 class="nav__app-name">CME Institute</h1>
    </div>
    <ul class="nav__items--primary">
      <li class="nav__item--primary"><a>Learn</a></li>
      <li class="nav__item--primary"><a>Practice</a></li>
      <li class="nav__item--primary"><a>Challenge</a></li>
      <li class="nav__item--primary"><a>Markets</a></li>
    </ul>
    <ul class="nav__actions">
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>
      <li class="nav__action"><button class="nav__action-btn js-dismissable-sidebar-panel__open js-dismissable-sidebar-panel__remote-open"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>
    </ul>
  </div>
</nav>
<div class="dismissable-sidebar-panels js-dismissable-sidebar-panel is-title is-compact is-right">
  <div class="dismissable-sidebar-panels__wrapper">
    <div class="dismissable-sidebar-panels__sidebar">
      <div class="dismissable-sidebar-panels__sidebar--heading">
        <h1 class="flush--bottom dismissable-sidebar-panels__sidebar--heading--title push-quarter--left">Events</h3>
        <button class="btn btn--transparent dismissable-sidebar-panels__sidebar--heading--hide js-dismissable-sidebar-panel__close text--right hard">
          <span class="dismissable-sidebar-panels__sidebar--heading--hide--icon">
            <i class="icon-cme-card-close icon--medium"></i>
          </span>
          <span class="dismissable-sidebar-panels__sidebar--heading--hide--close">
            <i class="icon-cme-close-circle-o"></i>
          </span>
        </button>
      </div>
      <div class="dismissable-sidebar-panels__sidebar--content"></div>
    </div>
    <div class="dismissable-sidebar-panels__content">
      <div class="well well--border-color push">
        <h3 class="flush">Results Content</h3>
        <button class="btn dismissable-sidebar-panels__content--action js-dismissable-sidebar-panel__remote-open push--top">
          <i class="dismissable-sidebar-panels__content--state js-dismissable-sidebar-panel__state fa icon-cme-filter"></i>
          <span class="push-quarter--left">Events</span>
        </button>
      </div>
    </div>
  </div>
</div>`}</code></pre>
      <br/>
      <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>
      <pre><code className="language-javascript">{`commonUI.initializeDismissableSidebarPanel({
  width: '50%',
});`}</code></pre>
      <hr/>
    </section>
  );
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/DismissableSidebarPanel.js